import React from 'react';

import FilledButton from 'components/Buttons/FilledButton';
import UnfilledButton from 'components/Buttons/UnfilledButton';
import Overlay from 'components/Informations/Overlay';

export const renderOverlay = (isOpen, setIsOpen, resetSelections) => (
  <Overlay
    isOpen={isOpen}
    type="warning"
    text={[
      'Se você prosseguir com esta ação estará ',
      <span>descartando</span>,
      ' todos os apontamentos realizados neste dia. Deseja prosseguir?',
    ]}
  >
    <UnfilledButton
      text="Sim, descartar"
      handleClick={() => [resetSelections(), setIsOpen(false)]}
    />

    <FilledButton
      text="Não"
      buttonClass="warn"
      handleClick={() => setIsOpen(false)}
    />
  </Overlay>
);
